/* eslint-disable @typescript-eslint/camelcase */
export const initConpass = ({ userInfos, dealerInfos }) => {
  const Conpass = window.Conpass;
  const ConpassDealerID =
    Conpass && Conpass.user && Conpass.user.custom_fields.dealerId;
  const dealerIdIsChanged = ConpassDealerID !== dealerInfos.dealerId;
  if (Conpass && dealerIdIsChanged) {
    window.Conpass.init({
      name: userInfos && userInfos.firstName,
      email: userInfos && userInfos.email,
      custom_fields: {
        dealerId: dealerInfos && dealerInfos.dealerId,
        dealerName: dealerInfos && dealerInfos.name,
        dealerStatus: dealerInfos && dealerInfos.status,
        dealerCityId: dealerInfos && dealerInfos.cityId,
        dealerAddress: dealerInfos && dealerInfos.address,
        dealerNumber: dealerInfos && dealerInfos.number,
        dealerZipCode: dealerInfos && dealerInfos.zipCode,
        dealerProducts: dealerInfos && dealerInfos.products,
      },
    });
  }
};
